//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MBD.js";
import "../no/TaggedObject.js";
let d=[[[0,"Name",0,0]],[[[],"GetInputType",{R_:{inputType:''}},0,0],[[],"IsRequired",{R_:{isRequired:''}},0,0],[[],"GetInputNodeName",{R_:{inputNodeName:''}},0,0]],[]];
SPLM.MBD.WebRuleInstanceInput = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MBD.WebRuleInstanceInput";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.MBD.WebRuleInstanceInput.InputType = Object.freeze({
    "Boolean" : "Boolean", "Double" : "Double", "Folder" : "Folder", "Integer" : "Integer", "Selection" : "Selection", "String" : "String", "Enum" : "Enum", "Color" : "Color", "Unsupported" : "Unsupported"});

export default SPLM;